module.exports = __webpack_public_path__ + "img/shuzi.34414544.png";